export default __webpack_public_path__ + "static/media/miltestes.a10e345d.png";